import type { DirectSaleItemEntity, DirectSaleListingItemEntity, DirectSaleNegotiationPlatformEntity, NegotiationEntity } from '~/apiClient';

export function isDirectSaleItemEntity(directSale: DirectSaleItemEntity | DirectSaleListingItemEntity): directSale is DirectSaleItemEntity {
    return !!(directSale as DirectSaleItemEntity).sellerCompanyId;
}

export interface DirectSaleItemEntityWithCurrentPrice extends Omit<DirectSaleItemEntity, 'price'> {
    price: number;
}

export function isDirectSaleItemEntityWithCurrentPrince(entity: DirectSaleItemEntity): entity is DirectSaleItemEntityWithCurrentPrice {
    return typeof entity.price === 'number';
}

export interface DirectSaleWithNegotiations extends Omit<DirectSaleItemEntity, 'negotiations'> {
    negotiations: DirectSaleNegotiationPlatformEntity[];
}

export function isDirectSaleWithNegotiations(directSale: DirectSaleItemEntity): directSale is DirectSaleWithNegotiations {
    return !!directSale.negotiations?.length;
}

export interface DirectSaleListingWithNegotiations extends Omit<DirectSaleListingItemEntity, 'negotiations'> {
    negotiations: NegotiationEntity[];
}

export function isDirectSaleListingWithNegotiations(
    directSaleListingItem: DirectSaleListingItemEntity
): directSaleListingItem is DirectSaleListingWithNegotiations {
    return !!directSaleListingItem.negotiations?.length;
}
